import { BalanceState } from "./slice";

export const balanceIsValid = (
  state: BalanceState
): state is BalanceState & {
  trust: number;
  frozen: number;
  payIn: number;
  payOut: number;
  save: number;
} => {
  return (
    !state.error &&
    !state.errorSave &&
    typeof state.trust === "number" &&
    typeof state.frozen === "number" &&
    typeof state.payIn === "number" &&
    typeof state.payOut === "number" &&
    typeof state.save === "number"
  );
};
